import React, { useEffect } from 'react'
import { setSupportedLanguages, useLanguage } from '../../context/Language'
import { LANGUAGE_CODES } from '../../types/language'
import { GatsbyPageContextObject } from '../../types/gatsby'

interface LanguageInitializerProps {
  pageContext?: GatsbyPageContextObject
}

const LanguageInitializer: React.FC<LanguageInitializerProps> = ({
  pageContext,
}) => {
  const { dispatch } = useLanguage()

  // Set the supported languages for the page
  useEffect(() => {
    const supportedLanguages = pageContext?.pageSupportedLanguages
    if (supportedLanguages) {
      // For content pages, we have a list of supported languages
      setSupportedLanguages(dispatch, supportedLanguages)
    } else {
      // For other pages, we use all supported languages
      setSupportedLanguages(dispatch, Array.from(LANGUAGE_CODES))
    }
  }, [dispatch, pageContext?.pageSupportedLanguages])

  return null
}

export default LanguageInitializer
